import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { Input } from '@/components/ui/input';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PatientSearch({ value, onChange, placeholder, className }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [allClients, setAllClients] = useState([]);
  const [selectedName, setSelectedName] = useState('');
  const wrapperRef = useRef(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await axios.get(`${API}/api/patients?search=`); setAllClients(data); } catch {}
    })();
  }, []);

  useEffect(() => {
    if (value && allClients.length > 0) {
      const found = allClients.find(c => c.user_id === value);
      if (found) setSelectedName(found.name || found.email || '');
    }
  }, [value, allClients]);

  useEffect(() => {
    if (!query.trim()) { setResults(allClients.slice(0, 10)); return; }
    const q = query.toLowerCase();
    setResults(allClients.filter(c => (c.name || '').toLowerCase().includes(q) || (c.email || '').toLowerCase().includes(q)).slice(0, 10));
  }, [query, allClients]);

  useEffect(() => {
    const handleClick = (e) => { if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const select = (client) => {
    onChange(client.user_id);
    setSelectedName(client.name || client.email || '');
    setQuery('');
    setOpen(false);
  };

  return (
    <div className={`relative ${className || ''}`} ref={wrapperRef}>
      <div className="relative">
        <MagnifyingGlass size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-muted" />
        <Input
          value={open ? query : selectedName}
          onChange={e => { setQuery(e.target.value); if (!open) setOpen(true); }}
          onFocus={() => { setOpen(true); setQuery(''); }}
          placeholder={placeholder || 'Pesquisar paciente...'}
          className="pl-8 rounded-xl border-brand-border text-sm"
          data-testid="patient-search-input"
        />
      </div>
      {open && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-brand-border rounded-xl shadow-lg max-h-48 overflow-y-auto">
          {results.length === 0 ? (
            <p className="text-xs text-brand-muted p-3 text-center">Sem resultados</p>
          ) : results.map(c => (
            <button key={c.user_id} onClick={() => select(c)} className="w-full text-left px-3 py-2 hover:bg-brand-bg/50 text-sm text-brand-text flex items-center justify-between" data-testid={`patient-option-${c.user_id}`}>
              <span>{c.name || c.email}</span>
              <span className="text-[9px] text-brand-muted">{c.patient_type || ''}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
